import type { InjectionKey } from "vue";
import { AttachmentsStore } from "../store/attachments";
import { UploadProgressBarStore } from "../store/uploadProgressBar";

export const DAYS_TO_ADD_ATTACHMENT_VALIDITY = 15;

export const RESET_DELAY_MS = 2000;

export const FILE_SIZE_MULTIPLIER = 1024;

export const FILE_SIZE_UNITS = ["bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

export const ATTACHMENT_PROVIDE_KEY: InjectionKey<AttachmentsStore> = Symbol("attachment-store");

export const UPLOAD_PROGRESS_BAR_PROVIDE_KEY: InjectionKey<UploadProgressBarStore> =
  Symbol("upload-progress-bar-store");
